module.exports = __webpack_public_path__ + "img/huangyunli.b8cd6ffd.jpg";